import { TFunction } from "i18next";

import { getTwoLettersCountryCode } from "./queries";
import { ILocation } from "./types";

export const formatLocation = (location?: Partial<ILocation> | null, invalidLocationString = "") => {
  if (!location) {
    return invalidLocationString;
  }

  const { name } = location;

  if (name) {
    return name;
  }

  return invalidLocationString;
};

export const formatLocationWithCountryCode = (location?: Partial<ILocation> | null) => {
  if (!location?.city) return "";

  const countryCode = getTwoLettersCountryCode(location.countryCode);
  const countryCodeString = countryCode ? ` (${countryCode})` : "";
  return `${location.city}${countryCodeString}`;
};

export const formatMultipleLocations = (
  t: TFunction,
  locations?: Array<Partial<ILocation>> | null,
  baseNumberOfLocationsShown = 2,
  invalidLocationString = "",
) => {
  if (!locations) {
    return invalidLocationString;
  }

  const orString = ` ${t("common:OTHER.OR")} `;

  if (locations.length === 1 && locations[0].name) {
    return formatLocationWithCountryCode(locations[0]);
  } else if (locations.length <= baseNumberOfLocationsShown) {
    return locations.map(location => formatLocationWithCountryCode(location)).join(orString);
  } else {
    return locations
      .slice(0, baseNumberOfLocationsShown)
      .map(location => formatLocationWithCountryCode(location))
      .join(orString);
  }
};

export const formatMultipleLocationsWithCounter = (
  t: TFunction,
  locations?: Array<Partial<ILocation>> | null,
  baseNumberOfLocationsShown = 2,
  invalidLocationString = "",
) => {
  if (!locations) {
    return invalidLocationString;
  }
  const counterIndicator =
    locations.length > baseNumberOfLocationsShown ? ` +\xa0${locations.length - baseNumberOfLocationsShown}` : "";

  return formatMultipleLocations(t, locations, baseNumberOfLocationsShown, invalidLocationString) + counterIndicator;
};
